import { Injectable, Injector } from '@angular/core';
import { Contractor } from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class ContractorsService extends CrudService<Contractor> {
  constructor(injector: Injector) {
    super(injector, Path.Contractors, Contractor);
  }
}
